import { z } from "zod"

export const AddProductConditionsSchema = z.object({
  stockType: z.string().nullable().optional(),
  excludedFromCombinedPricing: z.boolean().optional(),
  isOnAllocation: z.boolean().optional(),
  warehouseAreaIds: z.array(z.string()).optional().default([]),
})
